var _svg, _svg2;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import React from 'react';
export function PipIconOn() {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 10H11C10.4696 10 9.96086 10.2107 9.58579 10.5858C9.21071 10.9609 9 11.4696 9 12V15C9 15.5304 9.21071 16.0391 9.58579 16.4142C9.96086 16.7893 10.4696 17 11 17H16C16.5304 17 17.0391 16.7893 17.4142 16.4142C17.7893 16.0391 18 15.5304 18 15V12C18 11.4696 17.7893 10.9609 17.4142 10.5858C17.0391 10.2107 16.5304 10 16 10ZM17 15C17 15.2652 16.8946 15.5196 16.7071 15.7071C16.5196 15.8946 16.2652 16 16 16H11C10.7348 16 10.4804 15.8946 10.2929 15.7071C10.1054 15.5196 10 15.2652 10 15V12C10 11.7348 10.1054 11.4804 10.2929 11.2929C10.4804 11.1054 10.7348 11 11 11H16C16.2652 11 16.5196 11.1054 16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12V15Z",
    fill: "#2D3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13V5C1 4.73478 1.10536 4.48043 1.29289 4.29289C1.48043 4.10536 1.73478 4 2 4H14C14.2652 4 14.5196 4.10536 14.7071 4.29289C14.8946 4.48043 15 4.73478 15 5V9H16V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H2C1.46957 3 0.960859 3.21071 0.585786 3.58579C0.210714 3.96086 0 4.46957 0 5L0 13C0 13.5304 0.210714 14.0391 0.585786 14.4142C0.960859 14.7893 1.46957 15 2 15H8V14H2C1.73478 14 1.48043 13.8946 1.29289 13.7071C1.10536 13.5196 1 13.2652 1 13Z",
    fill: "#2D3B45"
  })));
}
export function PipIconOff() {
  return _svg2 || (_svg2 = /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9.85504H11C10.4696 9.85504 9.96086 10.0658 9.58579 10.4408C9.21071 10.8159 9 11.3246 9 11.855V14.855C9 15.3855 9.21071 15.8942 9.58579 16.2693C9.96086 16.6443 10.4696 16.855 11 16.855H16C16.5304 16.855 17.0391 16.6443 17.4142 16.2693C17.7893 15.8942 18 15.3855 18 14.855V11.855C18 11.3246 17.7893 10.8159 17.4142 10.4408C17.0391 10.0658 16.5304 9.85504 16 9.85504ZM17 14.855C17 15.1203 16.8946 15.3746 16.7071 15.5621C16.5196 15.7497 16.2652 15.855 16 15.855H11C10.7348 15.855 10.4804 15.7497 10.2929 15.5621C10.1054 15.3746 10 15.1203 10 14.855V11.855C10 11.5898 10.1054 11.3355 10.2929 11.1479C10.4804 10.9604 10.7348 10.855 11 10.855H16C16.2652 10.855 16.5196 10.9604 16.7071 11.1479C16.8946 11.3355 17 11.5898 17 11.855V14.855Z",
    fill: "#2D3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 4.85502V8.85502H16.0002V4.85502C15.9987 4.46527 15.8835 4.08443 15.6685 3.75931C15.4535 3.4342 15.1482 3.17898 14.7902 3.02502L14.1802 3.89502C14.4064 3.93635 14.6115 4.05439 14.7608 4.22926C14.9102 4.40412 14.9947 4.62512 15.0002 4.85502Z",
    fill: "#2D3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33008 14.895H8.01008V13.895H7.04008L6.33008 14.895Z",
    fill: "#2D3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.27 4.74502L14.27 1.88502L14.38 1.72502L13.6 1.14502L12.38 2.85502H2C1.46957 2.85502 0.960859 3.06573 0.585786 3.44081C0.210714 3.81588 0 4.32459 0 4.85502L0 12.855C0 13.3855 0.210714 13.8942 0.585786 14.2692C0.960859 14.6443 1.46957 14.855 2 14.855H3.84L2.92 16.155L3.73 16.735L5.07 14.855L5.78 13.855L12.27 4.74502ZM4.55 13.895H2C1.73478 13.895 1.48043 13.7897 1.29289 13.6021C1.10536 13.4146 1 13.1602 1 12.895V4.89502C1 4.6298 1.10536 4.37545 1.29289 4.18791C1.48043 4.00038 1.73478 3.89502 2 3.89502H11.67L4.55 13.895Z",
    fill: "#2D3B45"
  })));
}